import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#xbp87ztsr__clip0_21_25)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#k6hlv4f7p__clip1_21_25)",
          children: [_jsx("path", {
            d: "M-10 -3H30V23H-10V-3Z",
            fill: "white"
          }), _jsx("path", {
            d: "M-10 -3H30V5.66667H-10V-3Z",
            fill: "#FF6820"
          }), _jsx("path", {
            d: "M-10 14.3334H30V23H-10V14.3334Z",
            fill: "#046A38"
          }), _jsx("path", {
            d: "M9.99998 14.0082C12.2705 14.0082 14.1111 12.2137 14.1111 9.99991C14.1111 7.78617 12.2705 5.99158 9.99998 5.99158C7.72948 5.99158 5.88887 7.78617 5.88887 9.99991C5.88887 12.2137 7.72948 14.0082 9.99998 14.0082Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10 13.4667C11.9637 13.4667 13.5556 11.9146 13.5556 10.0001C13.5556 8.08547 11.9637 6.53339 10 6.53339C8.03633 6.53339 6.44446 8.08547 6.44446 10.0001C6.44446 11.9146 8.03633 13.4667 10 13.4667Z",
            fill: "white"
          }), _jsx("path", {
            d: "M10 10.6933C10.3927 10.6933 10.7111 10.3829 10.7111 9.99997C10.7111 9.61706 10.3927 9.30664 10 9.30664C9.60727 9.30664 9.28889 9.61706 9.28889 9.99997C9.28889 10.3829 9.60727 10.6933 10 10.6933Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M9.99997 6.53339L10.1333 8.61949L9.99997 9.65237L9.86664 8.61949L9.99997 6.53339Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10.4438 6.71336C10.5289 6.72429 10.6071 6.66583 10.6183 6.58278C10.6295 6.49974 10.5695 6.42355 10.4844 6.41262C10.3992 6.40169 10.321 6.46014 10.3098 6.54319C10.2986 6.62624 10.3586 6.70242 10.4438 6.71336Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10 13.4667L9.86666 11.3806L10 10.3477L10.1333 11.3806L10 13.4667Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M9.55621 13.2867C9.47104 13.2758 9.3929 13.3342 9.38168 13.4173C9.37047 13.5003 9.43043 13.5765 9.51561 13.5874C9.60078 13.5984 9.67892 13.5399 9.69013 13.4569C9.70135 13.3738 9.64139 13.2976 9.55621 13.2867Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10.9231 6.65048L10.4914 8.69948L10.0894 9.66511L10.2396 8.6341L10.9231 6.65048Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M11.3002 6.93819C11.3791 6.96978 11.4701 6.93227 11.5034 6.85441C11.5368 6.77656 11.4999 6.68784 11.421 6.65625C11.3422 6.62467 11.2512 6.66218 11.2178 6.74003C11.1844 6.81789 11.2213 6.90661 11.3002 6.93819Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M9.07684 13.3496L9.50855 11.3006L9.91055 10.335L9.76037 11.366L9.07684 13.3496Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M8.69975 13.0619C8.62087 13.0303 8.52987 13.0678 8.49651 13.1456C8.46314 13.2235 8.50003 13.3122 8.57891 13.3438C8.6578 13.3754 8.74879 13.3379 8.78216 13.26C8.81553 13.1822 8.77863 13.0935 8.69975 13.0619Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M11.7791 6.99707L10.8216 8.86898L10.1769 9.69989L10.5934 8.74068L11.7791 6.99707Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.0691 7.37079C12.1369 7.42143 12.2346 7.40832 12.2872 7.34151C12.3399 7.2747 12.3276 7.17949 12.2598 7.12886C12.192 7.07822 12.0944 7.09133 12.0417 7.15814C11.9891 7.22495 12.0013 7.32016 12.0691 7.37079Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M8.22081 13.003L9.17838 11.1311L9.82306 10.3002L9.40655 11.2594L8.22081 13.003Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.93084 12.6293C7.86305 12.5786 7.7654 12.5917 7.71274 12.6586C7.66007 12.7254 7.67233 12.8206 7.74012 12.8712C7.80791 12.9218 7.90556 12.9087 7.95823 12.8419C8.0109 12.7751 7.99863 12.6799 7.93084 12.6293Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.5151 7.54785L11.0942 9.11518L10.2512 9.75515L10.9076 8.93318L12.5151 7.54785Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.6968 7.98251C12.7488 8.04864 12.8464 8.06065 12.9149 8.00933C12.9834 7.95801 12.9968 7.8628 12.9448 7.79668C12.8929 7.73055 12.7952 7.71854 12.7267 7.76986C12.6582 7.82118 12.6448 7.91639 12.6968 7.98251Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.4849 12.4522L8.90577 10.8849L9.74881 10.2449L9.09243 11.0669L7.4849 12.4522Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.30322 12.0175C7.25126 11.9514 7.15361 11.9394 7.08511 11.9907C7.01662 12.042 7.00321 12.1373 7.05518 12.2034C7.10714 12.2695 7.20479 12.2815 7.27328 12.2302C7.34178 12.1789 7.35518 12.0837 7.30322 12.0175Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.0783 8.26812L11.2941 9.4233L10.3097 9.82488L11.159 9.1954L13.0783 8.26812Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.1419 8.73073C13.1752 8.8085 13.2662 8.84587 13.3452 8.8142C13.4241 8.78253 13.4612 8.6938 13.4279 8.61603C13.3946 8.53826 13.3037 8.50089 13.2247 8.53257C13.1457 8.56424 13.1086 8.65296 13.1419 8.73073Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.92169 11.7321L8.7059 10.5769L9.6903 10.1753L8.841 10.8048L6.92169 11.7321Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.8581 11.2695C6.82483 11.1917 6.73384 11.1543 6.65486 11.186C6.57588 11.2177 6.53883 11.3064 6.5721 11.3841C6.60537 11.4619 6.69636 11.4993 6.77534 11.4676C6.85432 11.4359 6.89137 11.3472 6.8581 11.2695Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.4339 9.10439L11.4029 9.76937L10.345 9.9086L11.3329 9.51518L13.4339 9.10439Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.3714 9.56675C13.383 9.65009 13.4611 9.70903 13.546 9.69839C13.6309 9.68775 13.6903 9.61156 13.6788 9.52822C13.6673 9.44488 13.5892 9.38594 13.5043 9.39658C13.4194 9.40722 13.3599 9.48341 13.3714 9.56675Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.5661 10.8957L8.59705 10.2307L9.655 10.0915L8.66712 10.4849L6.5661 10.8957Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.62854 10.4333C6.61703 10.35 6.53889 10.291 6.45401 10.3017C6.36913 10.3123 6.30966 10.3885 6.32117 10.4718C6.33268 10.5552 6.41082 10.6141 6.4957 10.6035C6.58058 10.5928 6.64005 10.5167 6.62854 10.4333Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.5548 10.0074L11.417 10.1201L10.3574 9.99258L11.4154 9.87491L13.5548 10.0074Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.3701 10.432C13.3593 10.5147 13.42 10.5909 13.5057 10.6022C13.5913 10.6135 13.6694 10.5557 13.6802 10.473C13.691 10.3903 13.6303 10.3141 13.5446 10.3028C13.459 10.2915 13.3808 10.3494 13.3701 10.432Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.44527 9.99253L8.58301 9.87986L9.64263 10.0074L8.58459 10.125L6.44527 9.99253Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.62994 9.5679C6.64069 9.48523 6.57999 9.40904 6.49436 9.39773C6.40872 9.38642 6.33058 9.44427 6.31983 9.52695C6.30907 9.60962 6.36977 9.6858 6.45541 9.69711C6.54104 9.70842 6.61918 9.65057 6.62994 9.5679Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.4345 10.8975L11.3333 10.4827L10.3444 10.0898L11.4021 10.2319L13.4345 10.8975Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.1411 11.2686C13.1083 11.3459 13.1461 11.4346 13.2255 11.4667C13.3049 11.4988 13.3959 11.4621 13.4287 11.3848C13.4616 11.3074 13.4238 11.2187 13.3444 11.1866C13.2649 11.1545 13.1739 11.1912 13.1411 11.2686Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.56549 9.10247L8.66673 9.51727L9.65567 9.91011L8.59794 9.76803L6.56549 9.10247Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.85891 8.73138C6.89173 8.65403 6.85396 8.56531 6.77453 8.53322C6.6951 8.50114 6.60411 8.53783 6.57129 8.61519C6.53846 8.69254 6.57624 8.78126 6.65567 8.81335C6.7351 8.84544 6.82609 8.80874 6.85891 8.73138Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M13.0783 11.7319L11.159 10.8046L10.3097 10.1751L11.2941 10.5767L13.0783 11.7319Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.698 12.0186C12.6454 12.0854 12.6576 12.1806 12.7254 12.2313C12.7932 12.2819 12.8909 12.2688 12.9435 12.202C12.9962 12.1352 12.9839 12.0399 12.9161 11.9893C12.8484 11.9387 12.7507 11.9518 12.698 12.0186Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M6.92169 8.26801L8.841 9.19529L9.6903 9.82477L8.7059 9.42318L6.92169 8.26801Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.30197 7.98128C7.35464 7.91447 7.34238 7.81926 7.27459 7.76863C7.2068 7.71799 7.10915 7.7311 7.05648 7.79791C7.00382 7.86472 7.01608 7.95993 7.08387 8.01057C7.15166 8.0612 7.24931 8.04809 7.30197 7.98128Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.5131 12.4503L10.9063 11.0695L10.2532 10.2469L11.097 10.8836L12.5131 12.4503Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M12.0705 12.6307C12.002 12.682 11.9885 12.7773 12.0404 12.8433C12.0923 12.9094 12.19 12.9214 12.2585 12.87C12.3271 12.8187 12.3405 12.7235 12.2886 12.6574C12.2367 12.5913 12.139 12.5793 12.0705 12.6307Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.48694 7.54956L9.09378 8.93031L9.7468 9.75293L8.90308 9.11623L7.48694 7.54956Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M7.92954 7.36937C7.99807 7.31802 8.01154 7.22281 7.95961 7.15672C7.90769 7.09063 7.81004 7.07868 7.74151 7.13004C7.67297 7.18139 7.65951 7.2766 7.71143 7.34269C7.76336 7.40878 7.86101 7.42073 7.92954 7.36937Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M11.7771 13.0017L10.592 11.2611L10.179 10.3014L10.8244 11.1302L11.7771 13.0017Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M11.3015 13.0629C11.2219 13.0952 11.1839 13.1839 11.2166 13.2611C11.2493 13.3383 11.3403 13.3747 11.4198 13.3425C11.4994 13.3103 11.5374 13.2215 11.5047 13.1443C11.4721 13.0671 11.3811 13.0307 11.3015 13.0629Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M8.22297 6.99818L9.408 8.73881L9.82104 9.69845L9.17565 8.86965L8.22297 6.99818Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M8.69856 6.93694C8.77812 6.90469 8.81614 6.81597 8.78346 6.73877C8.75078 6.66158 8.65978 6.62513 8.58022 6.65738C8.50065 6.68962 8.46263 6.77834 8.49531 6.85554C8.52799 6.93274 8.61899 6.96918 8.69856 6.93694Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10.9195 13.3483L10.2372 11.3674L10.093 10.336L10.4962 11.2997L10.9195 13.3483Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M10.4441 13.2868C10.3587 13.2978 10.2986 13.374 10.3096 13.4569C10.3207 13.5399 10.3989 13.5981 10.4842 13.587C10.5695 13.576 10.6297 13.4998 10.6186 13.4169C10.6075 13.334 10.5294 13.2757 10.4441 13.2868Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M9.08048 6.65167L9.76279 8.63252L9.907 9.66393L9.50379 8.70027L9.08048 6.65167Z",
            fill: "#07038D"
          }), _jsx("path", {
            d: "M9.55596 6.71317C9.64127 6.70211 9.70145 6.62592 9.69038 6.543C9.6793 6.46008 9.60116 6.40183 9.51585 6.41289C9.43053 6.42396 9.37035 6.50014 9.38143 6.58306C9.3925 6.66598 9.47064 6.72423 9.55596 6.71317Z",
            fill: "#07038D"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#0E1949"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "xbp87ztsr__clip0_21_25",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "k6hlv4f7p__clip1_21_25",
          children: _jsx("rect", {
            width: "40",
            height: "26",
            fill: "white",
            transform: "translate(-10 -3)"
          })
        })]
      })]
    }))
  });
};
export default Component;
